import { Component, Inject, OnInit, Type } from '@angular/core';
import { WizardPlugin } from '../../../../../decorators/wizard-plugin';
import { IPluginPreviewComponent } from '../../../../../interfaces/plugin-preview-component.interface';
import { IWizardPluginComponent } from '../../../../../interfaces/wizard-plugin-component.interface';
import { BasePluginData } from '../../../../../models/wizard-plugin-models/base-plugin-data';
import { CustomerAllocationData } from '../../../../../models/wizard-plugin-models/customer-allocation-data';
import { AdditionalInformationData } from '../../../../../models/wizard-plugin-models/additional-information-data';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '../../../../../decoration-base/error-handler.service';
import { CUSTOMER_ENTITY_SERVICE_TOKEN, REQUISITION_ENTITY_SERVICE_TOKEN } from '../../../../../injection-tokens/entity-service-tokens';
import { ICustomerEntityService } from '../../../../../interfaces/entities/customer-entity-service.interface';
import { IRequisitionEntityService } from '../../../../../interfaces/entities/requisition-entity-service-interface';
import { BillingDetailsData } from '../../../../../models/wizard-plugin-models/billing-details-data';
import { AdditionalInformationPreviewComponent } from './additional-information-preview/additional-information-preview.component';


@WizardPlugin({
  name: "Additional Information",
  optional: false,
  description: "Set Additional Information for the customer",
  dataModelType: AdditionalInformationData
})



@Component({
  selector: 'app-additional-information-plugin',
  templateUrl: './additional-information-plugin.component.html',
  styleUrl: './additional-information-plugin.component.css'
})
export class AdditionalInformationPluginComponent implements IWizardPluginComponent, OnInit {
  public pluginData: AdditionalInformationData = new AdditionalInformationData();
constructor(private fb: FormBuilder,
    private router: Router,
    @Inject(CUSTOMER_ENTITY_SERVICE_TOKEN) private customerService: ICustomerEntityService,
    @Inject(REQUISITION_ENTITY_SERVICE_TOKEN) private reqService: IRequisitionEntityService,
    private errorHandler: ErrorHandlerService
  ) {
    // Don't call createForm here - FormBuilder might not be ready
  }

  ngOnInit(): void {
    
  }
  
  getPluginData(): BasePluginData {
     return this.pluginData;
    }
    setPluginData(data: BasePluginData): void {
       if (data) {
             this.pluginData = data as AdditionalInformationData;
          }
    }
  
  
    validate(): boolean {
       return !!this.pluginData.finalComments;
    }
    isComplete(): boolean {
      return this.validate();
    }
    reset(): void {
      this.pluginData = new AdditionalInformationData();
    }
  
    asPreview?(): Type<IPluginPreviewComponent> {
      return AdditionalInformationPreviewComponent;
    }


}
